// `crypto.randomUUID()` exists on web (browser global) and Node, but NOT in
// React Native — Hermes has no global `crypto`, so calling it on iOS/Android
// throws "Property 'crypto' doesn't exist". An idempotency key only needs to be
// unique per request (not cryptographically strong), so fall back to a
// Math.random-based RFC-4122 v4 UUID on native.
export function newIdempotencyKey(): string {
  const c = globalThis.crypto;
  if (c && typeof c.randomUUID === 'function') {
    return c.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (ch) => {
    const r = (Math.random() * 16) | 0;
    const v = ch === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
